import { createContext, useContext } from 'react';

import type { ICommercialAddonsResponse, ICommercialPlanBundle } from '../../interfaces/quotes';
import type { AddonTypeById, CommercialAddonType } from '../../types/quotes';

export interface IBrokerContextValue {
  commercialAddons: ICommercialAddonsResponse;
  addonTypeById: AddonTypeById;
  getAddonType: (addonId: number) => CommercialAddonType | undefined;
  loadingAddons: boolean;
  commercialPlans: ICommercialPlanBundle[];
  loadingPlans: boolean;
}

export const BrokerContext = createContext<IBrokerContextValue | null>(null);

export const useBroker = (): IBrokerContextValue => {
  const context = useContext(BrokerContext);
  if (!context) {
    throw new Error('useBroker must be used within a BrokerProvider');
  }
  return context;
};
